var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.854 17.144a12.634 12.634 0 01-2.638-3.809.749.749 0 01.166-.827l.82-.818c.67-.67.67-1.62.084-2.206L12.112 8.31a2 2 0 00-2.828 0l-.652.652c-.74.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.45 2.45 5.31 3.967 7.923 4.461 1.06.2 2.13-.109 2.87-.85l.651-.65a2 2 0 000-2.829l-1.173-1.173a1.5 1.5 0 00-2.12 0l-.904.904a.749.749 0 01-.827.166 12.66 12.66 0 01-3.809-2.64z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPhone;